import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material'; 

@Component({
  selector: 'app-licenciasdev',
  templateUrl: './licenciasdev.component.html',
  styleUrls: ['./licenciasdev.component.css']
})
export class LicenciasdevComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<LicenciasdevComponent>,
  ) { }

  ngOnInit() {
  }

}
